/**
 * 🚀 Sistema di Logging Intelligente
 * 
 * In development: Mostra tutti i log
 * In production: Nasconde automaticamente i log (tranne errori)
 * 
 * Performance Impact:
 * - Elimina ~373 console.log in produzione
 * - Riduce memory leak e overhead browser
 * - Mantiene debug completo in sviluppo
 */

const isDevelopment = import.meta.env.DEV;

export const logger = {
  /**
   * Log generale - Solo in development
   */
  log: isDevelopment ? console.log.bind(console) : () => {},
  
  /**
   * Warning - Solo in development
   */
  warn: isDevelopment ? console.warn.bind(console) : () => {},
  
  /**
   * Debug dettagliato - Solo in development
   */
  debug: isDevelopment ? console.debug.bind(console) : () => {},
  
  /**
   * Informazioni - Solo in development
   */
  info: isDevelopment ? console.info.bind(console) : () => {},
  
  /**
   * Errori - SEMPRE visibili (anche in produzione)
   */
  error: console.error.bind(console),
  
  /**
   * Gruppi di log - Solo in development
   */
  group: isDevelopment ? console.group.bind(console) : () => {},
  groupCollapsed: isDevelopment ? console.groupCollapsed.bind(console) : () => {},
  groupEnd: isDevelopment ? console.groupEnd.bind(console) : () => {},
  
  /**
   * Performance timing - Solo in development
   */
  time: isDevelopment ? console.time.bind(console) : () => {},
  timeEnd: isDevelopment ? console.timeEnd.bind(console) : () => {},
  
  /**
   * Tabelle - Solo in development
   */
  table: isDevelopment ? console.table?.bind(console) || (() => {}) : () => {}
};

/**
 * Helper per log condizionale con emoji e colori
 */
export const createLogger = (prefix: string) => ({
  log: (message: string, ...args: any[]) => logger.log(`${prefix} ${message}`, ...args),
  warn: (message: string, ...args: any[]) => logger.warn(`${prefix} ⚠️  ${message}`, ...args),
  error: (message: string, ...args: any[]) => logger.error(`${prefix} ❌ ${message}`, ...args),
  debug: (message: string, ...args: any[]) => logger.debug(`${prefix} 🔍 ${message}`, ...args),
  info: (message: string, ...args: any[]) => logger.info(`${prefix} ℹ️  ${message}`, ...args),
  success: (message: string, ...args: any[]) => logger.log(`${prefix} ✅ ${message}`, ...args)
});

// Export default logger
export default logger;
